import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"src/app/(auth)/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"../fonts/Inter-Variable.woff2\",\"variable\":\"--font-sans\",\"weight\":\"100 900\"}],\"variableName\":\"interFont\"}");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["EnvironmentBanner"] */ "/app/src/components/environment-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/src/components/ui/sonner.tsx");
